import {
  text_colorTextPrimary,
  text_colorTextSecondary,
} from 'ext-ui/style/colors'
import { spacing } from 'ext-ui/style/spacing'
import {
  font_2xl,
  font_family_weight_medium,
  font_family_weight_regular,
  font_md,
} from 'ext-ui/style/typography'
import { css } from 'styled-components'

export default css`
  &.NormalizedMerchantFeedbackModal {
    display: flex;
    flex-direction: column;
    gap: ${spacing(6)};
    padding: ${spacing(6)};
    max-width: 500px;

    .modal-header {
      display: flex;
      flex-direction: column;
      gap: ${spacing(2)};
    }

    .modal-title {
      ${font_2xl};
      font-family: ${font_family_weight_medium};
      color: ${text_colorTextPrimary};
      margin: 0;
    }

    .modal-subtitle {
      ${font_md};
      font-family: ${font_family_weight_regular};
      color: ${text_colorTextSecondary};
      margin: 0;
    }

    .modal-body {
      display: flex;
      flex-direction: column;
      gap: ${spacing(4)};
    }

    .modal-footer {
      display: flex;
      flex-direction: row;
      gap: ${spacing(3)};
      justify-content: flex-end;
    }
  }
`
